module.exports = __webpack_public_path__ + "img/image-13.41f8a0be.webp";